import { Sizes } from './sizing';
import { TypographySettings } from './typography';

export const input = {
  font: {
    ...TypographySettings.subhead,
  },
  padding: {
    horizontal: Sizes[12],
    vertical: Sizes[14],
  },
};
